import { selfAxios } from "../../../../../axios/selfAxios.js";
async function reqSelectRegionById(id) {
  const {
    data: { data }
  } = await selfAxios.get("/ucenterapi/internal/region/selectRegionById", { params: { id }, _cache: true });
  return data;
}
export { reqSelectRegionById };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/ucenterapi/internal/region/selectRegionById/get.js